var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "help-circle",
    d: "M18,0A18,18,0,1,1,0,18,18,18,0,0,1,18,0Zm0,3.273A14.727,14.727,0,1,0,32.727,18,14.727,14.727,0,0,0,18,3.273Zm.016,21.273a1.636,1.636,0,0,1,.191,3.261L18,27.818a1.636,1.636,0,0,1-.191-3.261Zm.965-16.277a6.545,6.545,0,0,1,5.433,6.459,6.109,6.109,0,0,1-3.183,5.043,12.394,12.394,0,0,1-2.844,1.419,1.636,1.636,0,0,1-1.213-3.034l.491-.187c.092-.038.2-.082.314-.134a9.8,9.8,0,0,0,1.445-.787c1.116-.751,1.717-1.551,1.717-2.32a3.273,3.273,0,0,0-6.262-1.337l-.1.245a1.637,1.637,0,0,1-3.088-1.087,6.545,6.545,0,0,1,7.288-4.281Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCircle);
export default __webpack_public_path__ + "static/media/help-circle.db5847bc6b09c0e955bb6ce5c9b2a08b.svg";
export { ForwardRef as ReactComponent };